import { render, staticRenderFns } from "./CorpExpiredPage.vue?vue&type=template&id=14ab4a04&scoped=true"
import script from "./CorpExpiredPage.vue?vue&type=script&lang=js"
export * from "./CorpExpiredPage.vue?vue&type=script&lang=js"
import style0 from "./CorpExpiredPage.vue?vue&type=style&index=0&id=14ab4a04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ab4a04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
